webpackJsonp([272862233259567],{

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ProjectPage = __webpack_require__(9);
	
	var _ProjectPage2 = _interopRequireDefault(_ProjectPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var projectElements = {
		images: [{
			"src": "Nachbarschaft/neighbour_1",
			"orientation": "portrait"
		}, {
			"src": "Nachbarschaft/neighbour_3",
			"orientation": "portrait"
		}, {
			"src": "Nachbarschaft/neighbour_2",
			"orientation": "portrait"
		}, {
			"src": "Nachbarschaft/neighbour_4",
			"orientation": "portrait"
		}, {
			"src": "Nachbarschaft/neighbour_6",
			"orientation": "portrait"
		}, {
			"src": "Nachbarschaft/neighbour_8",
			"orientation": "portrait"
		}, {
			"src": "Nachbarschaft/neighbour_10",
			"orientation": "portrait"
		}, {
			"src": "Nachbarschaft/neighbour_14",
			"orientation": "portrait"
		}, {
			"src": "Nachbarschaft/neighbour_15",
			"orientation": "portrait"
		}, {
			"src": "Nachbarschaft/neighbour_7",
			"orientation": "portrait"
		}, {
			"src": "Nachbarschaft/neighbour_5",
			"orientation": "portrait"
		}, {
			"src": "Nachbarschaft/neighbour_9",
			"orientation": "portrait"
		}, {
			"src": "Nachbarschaft/neighbour_11",
			"orientation": "portrait"
		}, {
			"src": "Nachbarschaft/neighbour_12",
			"orientation": "portrait"
		}, {
			"src": "Nachbarschaft/neighbour_13",
			"orientation": "portrait"
		}]
	};
	
	var Nachbarschaft = function (_React$Component) {
		_inherits(Nachbarschaft, _React$Component);
	
		function Nachbarschaft() {
			_classCallCheck(this, Nachbarschaft);
	
			return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		}
	
		Nachbarschaft.prototype.render = function render() {
			return _react2.default.createElement(_ProjectPage2.default, {
				title: 'Nachbarschaft',
				text: 'F\xFCr die erste Version dieser Fotoserie habe ich die Wohnungst\xFCren meines Wohnhauses fotografiert. Die zweite Version  zeigte die Haust\xFCren meines H\xE4userblocks. Das Endprodukt wurde weiter auf die Fl\xE4che der Fassade von den H\xE4usern reduziert. W\xE4hrend diesem Projekt habe ich gelernt, dass man Ideen immer weiterentwickeln und verschiedenes ausprobieren sollte, bis  einen das Endprodukt zufrieden stellt. W\xE4hrend diesem Projekt habe ich mich intensiv mit der Pr\xE4sentationsform von Bildern  besch\xE4ftigt. Die Fotoserie wurde auf strukturiertem Papier ausgedruckt, da dieses die visuelle Struktur der Hausfassaden  auf den Fotos weiter verst\xE4rkt hat.',
				images: projectElements.images,
				layout: 'dreier' });
		};
	
		return Nachbarschaft;
	}(_react2.default.Component);
	
	exports.default = Nachbarschaft;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-neighbour-js-fd76856a0192b3c9feb8.js